import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type DrawerInitialStateTypes = {
  name: string;
};

const initialState = {
  name: "",
} as DrawerInitialStateTypes;

export const drawerSlice = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    closeDrawer: (state) => {
      state.name = "";
    },
    openDrawer: (state, action: PayloadAction<{ name: string }>) => {
      state.name = action.payload.name;
    },
  },
});

export const useDrawer = () => {
  const { name } = useAppSelector((state) => state.drawer);
  const dispatch = useAppDispatch();
  const dispatchOpenDrawer = useCallback(
    (name: string) => {
      dispatch(openDrawer({ name }));
    },
    [dispatch],
  );
  const dispatchCloseDrawer = useCallback(() => {
    dispatch(closeDrawer());
  }, [dispatch]);
  return {
    name,
    dispatchCloseDrawer,
    dispatchOpenDrawer,
  };
};

export const { openDrawer, closeDrawer } = drawerSlice.actions;
export default drawerSlice.reducer;
